import { Card } from 'primereact/card';
import { Skeleton } from 'primereact/skeleton';
import styles from '../../Dashboard.module.css';

export const LoadingSkeletons = () => (
  <>
    {Array.from({ length: 3 }).map((_, index) => (
      <Card key={index} className={styles.activityCard}>
        <div className={styles.activityHeader}>
          <Skeleton width="60%" height="1.5rem" />
          <Skeleton width="80px" height="24px" />
        </div>
        <div className={styles.activityDetails}>
          <Skeleton width="40%" height="1rem" />
          <Skeleton width="50%" height="1rem" />
          <Skeleton width="100px" height="24px" />
        </div>
      </Card>
    ))}
  </>
);
